import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=25e10d01&scoped=true"
import script from "./Database.vue?vue&type=script&lang=js"
export * from "./Database.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e10d01",
  null
  
)

export default component.exports